import { render } from "./AmountFunds.vue?vue&type=template&id=159f6c49&scoped=true"
import script from "./AmountFunds.vue?vue&type=script&lang=js"
export * from "./AmountFunds.vue?vue&type=script&lang=js"

import "./AmountFunds.vue?vue&type=style&index=0&id=159f6c49&scoped=true&lang=stylus"

import exportComponent from "D:\\GameProject\\h5yaoji\\H5-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-159f6c49"]])

export default __exports__